"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _StepLayout = require("./StepLayout");
Object.keys(_StepLayout).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _StepLayout[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _StepLayout[key];
    }
  });
});